import { Icon, IIconProps } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTheme } from 'theme'

export type StatusIconProps = Omit<IIconProps, 'iconName' | 'styles'> & {
  value?: any
}
export type Status1IconProps = Omit<StatusIconProps, 'value'>
export type Status2IconProps = Omit<StatusIconProps, 'value'>
export type Status3IconProps = Omit<StatusIconProps, 'value'>
export type Status1Props = Omit<StatusIconProps, 'value'>

export const Status1Icon: React.FunctionComponent<Status1IconProps> = (
  props
) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="FavoriteStar"
      styles={{ root: { color: theme.palette.yellowDark } }}
      {...props}
    />
  )
}
export const Status2Icon: React.FunctionComponent<Status2IconProps> = (
  props
) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="hourglass"
      styles={{ root: { color: theme.palette.blueDark } }}
      {...props}
    />
  )
}
export const Status3Icon: React.FunctionComponent<Status3IconProps> = (
  props
) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="CheckMark"
      styles={{ root: { color: theme.palette.greenDark } }}
      {...props}
    />
  )
}

export const Status0: React.FC<Status1Props> = (props) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="Edit"
      styles={{ root: { color: theme.palette.black } }}
      {...props}
    />
  )
}

export const Status1: React.FC<Status1Props> = (props) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="FavoriteStar"
      styles={{ root: { color: theme.palette.yellowDark } }}
      {...props}
    />
  )
}

export const Status2: React.FC<Status1Props> = (props) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="View"
      styles={{ root: { color: theme.palette.black } }}
      {...props}
    />
  )
}

export const Status3: React.FC<Status1Props> = (props) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="HourGlass"
      styles={{ root: { color: theme.palette.blueDark } }}
      {...props}
    />
  )
}

export const Status4: React.FC<Status1Props> = (props) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="Accept"
      styles={{ root: { color: theme.palette.greenDark } }}
      {...props}
    />
  )
}

export const Status5: React.FC<Status1Props> = (props) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="Important"
      styles={{ root: { color: theme.palette.redDark } }}
      {...props}
    />
  )
}

export const Status6: React.FC<Status1Props> = (props) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="View"
      styles={{ root: { color: theme.palette.blueDark } }}
      {...props}
    />
  )
}

export const Status7: React.FC<Status1Props> = (props) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="Sync"
      styles={{ root: { color: theme.palette.blueDark } }}
      {...props}
    />
  )
}

export const Status8: React.FC<Status1Props> = (props) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="Archive"
      styles={{ root: { color: theme.palette.yellowDark } }}
      {...props}
    />
  )
}

export const Status9: React.FC<Status1Props> = (props) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="CalculatorMultiply"
      styles={{ root: { color: theme.palette.blueDark } }}
      {...props}
    />
  )
}

export const Status10: React.FC<Status1Props> = (props) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="Blocked2"
      styles={{ root: { color: theme.palette.blueDark } }}
      {...props}
    />
  )
}

export const StatusIcon: React.FunctionComponent<StatusIconProps> = ({
  value,
  ...props
}) => {
  const val = value.status || value

  return (
    <>
      {val === 'open' && <Status1Icon {...props} />}
      {val === 'inProgress' && <Status2Icon {...props} />}
      {val === 'workInProgress' && <Status2Icon {...props} />}
      {val === 'finished' && <Status3Icon {...props} />}
      {val === 0 && <Status0 {...props} />}
      {val === 1 && <Status1 {...props} />}
      {val === 2 && <Status2 {...props} />}
      {val === 3 && <Status3 {...props} />}
      {val === 4 && <Status4 {...props} />}
      {val === 5 && <Status5 {...props} />}
      {val === 6 && <Status6 {...props} />}
      {val === 7 && <Status7 {...props} />}
      {val === 8 && <Status8 {...props} />}
      {val === 9 && <Status9 {...props} />}
      {val === 10 && <Status10 {...props} />}
    </>
  )
}
